import React, { useState } from "react";
import { Container } from "react-bootstrap";
import HeaderBar from "./HeaderBar";
import classes from "./TopBar.module.css";

const Content = ({ setNav, hideBarPages, confirmLogout }) => {
	function showSideBar(star) {
		setNav(star);
	}

	return (
		<Container fluid className={classes.content}>
			<HeaderBar
				setSideBar={showSideBar}
				hideBarPages={hideBarPages}
				confirmLogout={confirmLogout} 
			/>
		</Container>
	);
};

export default Content;